export function isCopyKey(event: KeyboardEvent): boolean {
  return event?.ctrlKey || event?.metaKey
}

export function isSingleKey(event: KeyboardEvent): boolean {
  return !isAdditionalKeyPressed(event)
}

function isAdditionalKeyPressed(event: KeyboardEvent): boolean {
  return event?.altKey || event?.ctrlKey || event?.metaKey || event?.shiftKey
}
